<template>
  <layout-navigation>
    <section :class="$style.page">
      <header :class="$style.header">
        {{ $t('program.aboutProgram') }}
      </header>
      <router-view />
    </section>
  </layout-navigation>
</template>

<script>
  import LayoutNavigation from '@/layouts/navigation.vue';

  export default {
    components: {
      LayoutNavigation,
    },
  };
</script>

<style lang="scss" module>
  .page {
    background: $white;
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;
  }

  .header {
    box-shadow: $shadow;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    padding: 20px 30px;
    font-weight: 500;
  }
</style>
